import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BB_PROGRAM_IDS, BB_ROLE_IDS, LLTTF_PROGRAM_IDS, LLTTF_ROLE_IDS } from 'src/app/components/authorize/admin-program-mode';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { UserQueryFilter, UserQueryFilterDefaultValues, UsersList } from 'src/app/components/users/user-list';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
    standalone: false
})
export class UsersListComponent {
  queryFilter: UserQueryFilter = UserQueryFilterDefaultValues();
  totalRecords: number = 0;
  users: UsersList[] = [];
  columnsToDisplay = [
    'Name',
    'Roles',
    'Program',
    'lastactive',
    'Status',
  ];
  applicationRoles: any[] = [];
  private allApplicationRoles: any[] = [];
  private allPrograms: any[] = [];
  pageName = CheckPageAccess.USERMANAGEMENT;
  showAddButton = true;
  programs: any[] = [];
  information: string = '';

  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('searchButton') searchButton!: ElementRef;

  constructor(private userservice: UserService,
    private authservice: AuthService,
    private progservice: ApplicationProgramsService) {
  }

  ngOnInit(): void {
    this.information = "<h4>Status Definitions</h4>" +
      "<br/><span>Active:</span> This user is currently enabled and has access to the system.<br/><br/>" +
      "<span>Inactive:</span> This user is disabled and does not have access to the system.";

    this.applyProgramModeToFilter();

    this.userservice.getApplicationRolesForUserFiltering().subscribe({
      next: (data) => {
        this.allApplicationRoles = data;
        this.applyProgramScopedFilters();
      }
    });

    this.progservice.getProgramsForUserListing().subscribe({
      next: (data) => {
        this.allPrograms = data;
        this.applyProgramScopedFilters();
      }
    });

    this.showAddButton = this.authservice.getAccessControl().addUser;
    this.searchWithFilters();
  }

  private applyProgramModeToFilter() {
    this.queryFilter.programMode = this.authservice.getEffectiveProgramMode();
  }

  private applyProgramScopedFilters() {
    const mode = this.authservice.getEffectiveProgramMode();
    const roleIds = mode === 'llttf' ? LLTTF_ROLE_IDS : BB_ROLE_IDS;
    const programIds = mode === 'llttf' ? LLTTF_PROGRAM_IDS : BB_PROGRAM_IDS;
    this.applicationRoles = this.allApplicationRoles.filter((r: any) => roleIds.includes(r.id));
    this.programs = this.allPrograms.filter((p: any) => programIds.includes(p.id));
  }

  private searchWithFilters() {
    this.applyProgramModeToFilter();

    this.userservice.getAllUsers(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.users = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  search() {
    this.searchWithFilters();
  }

  resetFilters() {
    this.queryFilter = UserQueryFilterDefaultValues();
    this.applyProgramModeToFilter();
    this.searchWithFilters();
  }

  getInitials(name: string): string {
    if (!name) {
      return '?';
    }

    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex;
    this.queryFilter.PageSize = e.pageSize;
    this.searchWithFilters();
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
  }
}
